// Cross-tab / cross-page data-change event bus (iter 36.7 Phase 3).
//
// Any component that mutates users, teams, projects, or the sidebar tree
// should call `emitDataChanged()`. Any component that fetches these lists
// subscribes with `useDataBus(reload)` and gets called back instantly.
//
// The bus is intentionally global (a window CustomEvent) so it works across
// portalled dialogs, deep components, and pages without needing a shared
// context provider. Payload is a small tag so subscribers can filter if
// they only care about certain kinds of mutations.

import { useEffect } from "react";

const EVENT_NAME = "pluto:data-changed";

export function emitDataChanged(kind = "any") {
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { kind } }));
  } catch (e) { /* no-op — SSR / non-browser */ }
}

// React hook — subscribe to data changes. Optional `kinds` array filters
// which mutations trigger the callback (default: all).
export function useDataBus(cb, kinds) {
  useEffect(() => {
    if (typeof cb !== "function") return;
    const handler = (e) => {
      const k = e?.detail?.kind || "any";
      if (kinds && Array.isArray(kinds) && !kinds.includes(k) && !kinds.includes("any")) return;
      cb(k);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cb]);
}
